export default class RevistaService {
  constructor($q, UIService, AuthenticationService, AuthorizationService, Revista, Publicacao) {
    this.$q = $q;
    this.UI = UIService;
    this.Auth = AuthenticationService;
    this.AuthorizationService = AuthorizationService;
    this.Revista = Revista;
    this.Publicacao = Publicacao;
    this.user = this.Auth.getUser();
  }

  // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
  setWhereField = (data, whereObject, whereOrObject) => {
    // Check if have this entry in whereOr already
    if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
      whereOrObject.push({key: data.key, value: data.value});
    } else { // Not in OR, check if there's an entry of this key in whereObject already
      if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
        whereOrObject.push({key: data.key, value: whereObject[data.key]});
        delete whereObject[data.key];
        whereOrObject.push({key: data.key, value: data.value});
      } else { // It's the first entry of this key, use whereObject only
        whereObject[data.key] = data.value;
      }
    }
  };

  // Returns a whereFields object to use in table() remote methods (ativo, interacao)
  // WhereLiteral should be defined locally
  setWhereFields = (customFilters, literal, orsLiteral) => {
    let where = {};
    let whereDates = [];
    let whereNextDates = [];
    let whereLiteral = literal || {};
    let whereOrLiteral = orsLiteral || [];
    let whereOr = [];

    customFilters.forEach(f => {
      let data = {};
      data.key = f.column.selected.id;
      // Generated dates - Assuming if no . exists in field, it's always generated date
      if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
        whereNextDates.push({
          key: data.key,
          comp: f.values.selected.val,
          value: f.value,
          format: f.column.selected.format
        });
      } else { // All other cases where fields exist in database
        if (f.column.selected.type === 'o') {
          data.value = f.value;

          this.setWhereField(data, where, whereOr);
        } else {
          if (f.column.selected.type === 'd') {
            whereDates.push({
              key: data.key,
              comp: f.values.selected.val,
              value: f.value,
              format: f.column.selected.format
            });
          } else {
            // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
            if (f.value.selected.id)
              data.value = f.value.selected.id;
            else
              data.value = f.value.selected.value;

            this.setWhereField(data, whereLiteral, whereOrLiteral);
          }
        }
      }
    });
    return {
      where: where,
      whereDates: whereDates,
      whereNextDates: whereNextDates,
      whereLiteral: whereLiteral,
      whereOr: whereOr,
      whereOrLiteral: whereOrLiteral
    };
  };


  // ISSN in the format ____-____
  isValidISSN = (issn) => {
    if (issn == null || issn == undefined || !issn) return false;
    let m = String(issn).match(/^(\d{4})-(\d{3}[\d|X])$/);
    if (!m) return false;


    let checksum = issn[issn.length - 1];
    let digits = m[1] + m[2];
    digits = digits.slice(0, -1);

    let total = 0;
    for (let i = 0; i < digits.length; i++) {
      total += Number(digits[i]) * (8 - i);
    }

    let result = (11 - (total % 11)) % 11;
    if (result < 10) result = String(result);
    else result = 'X';

    return checksum === result;
  };


  // Check if id exists for Model
  fieldValueExists = (field, value, Model) => {
    let defer = this.$q.defer();
    let where = {};
    where[field] = value;
    Model.count({
      where: where
    }).$promise.then((data) => {
      defer.resolve(data.count > 0);
    }).catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };


  // Check if partialData - {key1: data1, key2: data2} is already used in Model, returns count
  // If exceptId, do not search for id: exceptId
  usedPartialDataForModel = (partialData, Model, exceptId) => {
    let defer = this.$q.defer();
    let and = [];
    Object.keys(partialData).forEach(k => {
      let o = {};
      o[k] = partialData[k];
      and.push(o);
    });
    // Exclude exceptId
    if (exceptId)
      and.push({id: {neq: exceptId}});

    let where = {and: and};
    Model.count({
      where: where
    }).$promise.then((res) => {
      defer.resolve(res);
    }).catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };

  // Go through an array of field, value and models, and resolve/reject if all fields and values exist/not exist in those tables
  validateMultiData = (data) => {
    let multiDefer = this.$q.defer();

    let tasks = [];
    for (let i = 0; i < data.length; i++) {
      let defer = this.$q.defer();

      this.fieldValueExists(data[i].field, data[i].value, data[i].model).then((exists) => {
        if (exists) {
          if (data[i].resolveOnExist) { // Check if it's a "Exists, so resolve" or "Exists, so reject"
            defer.resolve();
          }
          else {
            this.UI.addToast(data[i].error);
            defer.reject();
          }
        } else {
          if (data[i].resolveOnExist) {
            this.UI.addToast(data[i].error);
            defer.reject();
          } else {
            defer.resolve();
          }
        }
      }).catch(err => {
        this.UI.addToast("Não foi possível verificar dados. Verifique a ligação");
        defer.reject();
      });
      tasks.push(defer.promise);
    }

    this.$q.all(tasks).then(x => {
      multiDefer.resolve(tasks);
    }).catch(err => {
      multiDefer.reject(err);
    });

    return multiDefer.promise;
  };

  // Create all multiple data revista, referenced by referenceId (ex. revistaId)
  createMultipleData = (Model, data, referenceId, reference) => {
    let multipleDataDefer = this.$q.defer();

    // Create multiple Data
    let tasks = [];
    for (let i = 0; i < data.length; i++) {
      let defer = this.$q.defer();
      let item = data[i];
      item.id = 0;
      item[reference] = referenceId;;
      item.criadoPorId = this.user.id;
      item.dataCriacao = moment().format();
      item.atualizadoPorId = this.user.id;
      item.atualizadoa = moment().format();
      Model.create(item).$promise.then((newItem) => {
        defer.resolve(newItem);
      }).catch((error) => {
        console.log(error);
        defer.reject(error);
      });
      tasks.push(defer.promise);
    }

    // After all data is created
    this.$q.all(tasks).then((res) => {
      multipleDataDefer.resolve(tasks);
    }).catch(err => {
      console.log(err);
      multipleDataDefer.reject(err);
    });

    return multipleDataDefer.promise;
  };

  // Update data with criadoPor, dataCriacao; data is array of objects
  updateMultipleData = (Model, data) => {
    let multipleDataDefer = this.$q.defer();

    // Create multiple Data
    let tasks = [];
    for (let i = 0; i < data.length; i++) {
      let defer = this.$q.defer();
      let item = data[i];
      item.atualizadoPorId = this.user.id;
      item.atualizadoa = moment().format();
      Model.upsert(item).$promise.then((newItem) => {
        defer.resolve(newItem);
      }).catch((error) => {
        console.log(error);
        defer.reject(error);
      });
      tasks.push(defer.promise);
    }

    // After all data is updated
    this.$q.all(tasks).then((res) => {
      multipleDataDefer.resolve(tasks);
    }).catch(err => {
      console.log(err);
      multipleDataDefer.reject(err);
    });

    return multipleDataDefer.promise;
  };


  // Check if user is associated with revista
  getAssociation = (userId, revista) => {
    let association = {
      isAssociated: false,
      associationCount: 0
    };
    if (!revista.equipaEditorial || revista.equipaEditorial.length === 0)
      return association;
    for (let i = 0; i < revista.equipaEditorial.length; i++) {
      if (revista.equipaEditorial[i].investigador && revista.equipaEditorial[i].investigador.userId === userId) {
        association.isAssociated = true;
        association.associationCount = association.associationCount + 1;
        association.investigadorId = revista.equipaEditorial[i].investigadorId;
      }
    }
    return association;
  };

  // Ask confirmation to delete
  confirmDeleteRevista = (x) => {
    let defer = this.$q.defer();
    let wait = this.UI.showWaiting();
    // Find publicacoes associadas
    this.Publicacao.find({
      filter: {
        where: {
          revistaId: x.id
        }
      }
    }).$promise.then((pubs) => {
      if (pubs && pubs.length > 0) {
        wait.close();
        let okString;
        if (pubs.length === 1) {
          okString = 'Não é possível eliminar revista, pois existe 1 publicação associada.';
        } else {
          okString = `Não é possível eliminar revista, pois existem ${pubs.length} publicações associadas.`;
        }
        let alert = this.UI.showAlert(okString);
        alert.finally(() => {
          defer.resolve();
        });
      } else { // No Publicacoes associadas, can carry on
        this.Revista.findById({id: x.id,
          filter: {
            include: {
              relation: 'equipaEditorial',
              scope: {
                include: 'investigador'
              }
            }

          }
        }).$promise.then((revista) => {
          // Options for modal
          let options = undefined;
          // Check if user is associated (as investigador) with revista
          let association = this.getAssociation(this.user.id, revista);

          // If created revista and has appropriate permission
          if ((this.user.id === x.criadoPorId && this.AuthorizationService.canPerform('revistaDelete')) || this.AuthorizationService.canPerform('revistaDeleteAny')) {
            // If user has relation with revista
            if (association.isAssociated) {
              // Only user to be related (if at all) with revista
              let otherAssociations = revista.equipaEditorial.length - association.associationCount;
              if (otherAssociations === 0) {
                options = {
                  title: "Remover Revista",
                  message: "Tem a certeza que pretende remover esta revista?",
                  firstButtonLabel: "Apagar Revista"
                };
              } else { // There are other users related to revista
                options = {
                  title: "Remover Revista",
                  message: "Há " + otherAssociations + (otherAssociations === 1 ? " outra ligação de investigador" : " outras ligações de investigadores") + " à equipa editorial da revista. Tem a certeza que pretende remover a revista ou apenas o registo global da sua ligação à revista?",
                  secondButtonLabel: "Apagar Ligação à Revista",
                  firstButtonLabel: "Apagar Revista"
                };
              }
            } else { // User has no relation with revista, but created it
              options = {
                title: "Remover Revista",
                message: "Há " + revista.equipaEditorial.length + (revista.equipaEditorial.length === 1 ? " ligação de investigador" : " ligações de investigadores") + " a esta revista. Tem a certeza que pretende remover a revista e consequentemente apagar todas as ligações à revista?",
                firstButtonLabel: "Apagar Revista"
              };
            }
          } else { // Did not create revista
            // Has association with revista
            if (association.isAssociated) {
              options = {
                title: "Remover Ligação a Revista",
                message: "Tem a certeza que pretende remover o registo global da sua ligação à revista?",
                secondButtonLabel: "Apagar Ligação à Revista"
              };
            } else { // Has no association with revista
              options = {
                title: "Remover Revista",
                message: "Não tem permissões para eliminar esta revista",
                cancelButtonLabel: "Fechar"
              };
            }
          }

          this.modalDeleteRevista(x, options).then(selection => {
            if (selection.firstButton) {
              // Delete revista
              this.Revista.deleteRevista({id: x.id}).$promise.then(() => {
                wait.close();
                this.UI.addToast("Revista removida com sucesso");
                defer.resolve();
              }).catch (error => {
                wait.close();
                console.log(error);
                let alert = this.UI.showAlert("Erro ao remover revista" + (error.message ? (": " + error.message) : (".")));
                alert.finally(() => {
                  defer.resolve();
                });
              });
            } else if (selection.secondButton) {
              // Delete all instances as membro da equipa
              this.Revista.removeMembroEquipa({investigadorId: association.investigadorId, revistaId: x.id}).$promise.then(() => {
                wait.close();
                this.UI.addToast("Removidas todas as ligações à revista com sucesso");
                defer.resolve();
              }).catch(error => {
                wait.close();
                console.log(error);
                let alert = this.UI.showAlert("Erro ao remover enquanto membro de equipa editorial" + (error.message ? (": " + error.message) : (".")));
                alert.finally(() => {
                  defer.resolve();
                });
              });
            } else {
              // Do nothing
              wait.close();
              defer.resolve();
            }
          }).catch(err => { // Shouldn't get here
            console.log(err);
            wait.close();
            defer.resolve();
          });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível consultar revista. Verifique a ligação");
          defer.resolve();
        });
      }
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível consultar publicações associadas à revista. Verifique a ligação");
      defer.resolve();
    });
    return defer.promise;
  };

  // Show modal with appropriate options
  modalDeleteRevista = (x, options) => {
    let defer = this.$q.defer();
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../interface/modals/delete-selected-options.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = options.title;
        $scope.message = options.message;
        $scope.cancelButtonLabel = options.cancelButtonLabel || 'Cancelar';
        $scope.firstButtonLabel = options.firstButtonLabel;
        $scope.secondButtonLabel = options.secondButtonLabel;
        $scope.firstButtonSelected = false;
        $scope.secondButtonSelected = false;

        $scope.firstButton = function () {
          $scope.$close({firstButton: true});
        };
        $scope.secondButton = function () {
          $scope.$close({secondButton: true});
        };

        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then((selection) => {
      defer.resolve(selection);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
      defer.resolve({});
    });
    return defer.promise;
  };

  checkRevistaPublicacao = (revista) => {
    let defer = this.$q.defer();
    this.Revista.checkRevistaPublicacao({revista: revista}).$promise.then(() => {
      defer.resolve();
    }).catch(error => {
      console.log(error);
      defer.reject(error);
    });
    return defer.promise;
  };


  // Permissions

  getEquipaEditorialUserId = (data) => {
    if (data) {
      let ids = [data.criadoPorId];
      if (data.equipaEditorial) {
        ids = ids.concat(data.equipaEditorial.map(x => x.investigador ? x.investigador.userId : null));
      }
      return ids;
    } else {
      return [];
    }
  };

  // Returns true or false if the user can edit something or not
  // ownPermission - permission to read your instance
  // allowAll - can read all instances of
  // adminPermission - permission to read all instances
  canRead = (ownPermission, allowAll, adminPermission, users) => {
    // If you have admin permission, return true
    if (this.AuthorizationService.canPerform(adminPermission)) {
      return true;
    } else {
      if (this.AuthorizationService.canPerform(ownPermission)) {
        if (allowAll) {
          return true;
        } else {
          return !!(users && users.includes(this.user.id));
        }
      } else {
        return false;
      }
    }
  };

  // Returns true or false if the user can edit something or not
  // ownPermission - permission to edit your instance
  // allowOwn - can edit your own
  // adminPermission - permission to read all instances
  canEdit = (ownPermission, allowOwn, adminPermission, users) => {
    // If you have admin permission, return true
    if (this.AuthorizationService.canPerform(adminPermission)) {
      return true;
    } else {
      if (!allowOwn) {
        return false;
      } else {
        if (users && users.includes(this.user.id)) {
          return this.AuthorizationService.canPerform(ownPermission);
        } else {
          return false;
        }
      }
    }
  };

}

RevistaService.$inject = ['$q', 'UIService', 'AuthenticationService', 'AuthorizationService', 'Revista', 'Publicacao'];
